import { api } from './client';
import type { Role, User } from '@/types';

export function listUsers(): Promise<User[]> {
  return api<User[]>('/api/users?limit=200');
}

export interface CreateUserInput {
  email: string;
  password: string;
  display_name?: string | null;
  role: Role;
  org_id?: string | null;
}

export function createUser(input: CreateUserInput): Promise<User> {
  return api<User>('/api/users', { method: 'POST', body: input });
}

export function resetPassword(id: string, new_password: string): Promise<void> {
  return api<void>(`/api/users/${id}/password`, { method: 'PATCH', body: { new_password } });
}

export function changeOwnPassword(current_password: string, new_password: string): Promise<void> {
  return api<void>('/api/users/me/password', {
    method: 'PATCH',
    body: { current_password, new_password },
  });
}

export function adjustBalance(id: string, delta_seconds: number): Promise<User> {
  return api<User>(`/api/users/${id}/balance`, {
    method: 'PATCH',
    body: { delta_seconds },
  });
}

export function updateRole(id: string, role: Role): Promise<User> {
  return api<User>(`/api/users/${id}/role`, { method: 'PATCH', body: { role } });
}

export function setDisabled(id: string, disabled: boolean): Promise<User> {
  return api<User>(`/api/users/${id}/disabled`, { method: 'PATCH', body: { disabled } });
}

export function logoutAll(id: string): Promise<void> {
  return api<void>(`/api/users/${id}/logout-all`, { method: 'POST' });
}

export function updatePermissions(
  id: string,
  perms: { can_delete_sessions?: boolean; can_delete_users?: boolean },
): Promise<User> {
  return api<User>(`/api/users/${id}/permissions`, { method: 'PATCH', body: perms });
}

export function deleteUser(id: string): Promise<void> {
  return api<void>(`/api/users/${id}`, { method: 'DELETE' });
}
